module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "view-note-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.capitalizedText
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "text-center py-5"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Loading..."
    }
  })], 1) : _c('div', [_c('b-row', [_c('b-col', {
    staticClass: "text-right mb-3",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.pdf_link != '') ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.PrintNote(_vm.JOB_NO, _vm.pdf_link)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o mr-1"
  }), _vm._v(" View PDF\n               ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "view-note-container"
  }, [_c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.agentType || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("To")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.AgentColoader || '-'))])])]), _vm._v(" "), (_vm.noteModal.agentType == 'Consignee') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("Consignee Address")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.agentconsigneeAddress || '-'))])])]) : _vm._e(), _vm._v(" "), (_vm.noteModal.agentType == 'Agent') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("Agent Country")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.agent_country || '-'))])])]) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("Vessel/Voy")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.vesselVoy || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("HBL/AWB")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.house_bl_no || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("MBL/MAWB")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.master_bl_no || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("SHIPPER")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.clientName || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("CONSIGNEE")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.consignee || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("Destination")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.FPOD || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.containerNoArryNote || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.containersTypes || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("SHIPPER INV.")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.ShipperInvDet || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("Booking No")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.validBookingNo || '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("SOB")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.SOB ? _vm.moment(_vm.noteModal.SOB) : '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("ETA Dest")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteModal.ETADest ? _vm.moment(_vm.noteModal.ETADest) : '-'))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "view-field"
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('div', {
    staticClass: "value",
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.noteModal.remarks || '-'))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-3 note-table"
  }, [_c('thead', {
    staticClass: "bg-light"
  }, [(_vm.noteParticulars.length > 0) ? _c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Final Amt")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Currency")])]) : _vm._e()]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_vm._l((_vm.noteParticulars), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      staticClass: "text-center align-middle",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_vm._v("\n                " + _vm._s(item.parti) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle small"
    }, [_vm._v("\n                  " + _vm._s(item.container_selected || '-') + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v("\n                  " + _vm._s(item.qty) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right align-middle"
    }, [_vm._v("\n                " + _vm._s(item.amt) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right align-middle"
    }, [_vm._v("\n                  " + _vm._s(item.final_amt) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v("\n                 " + _vm._s(_vm.getCurrencyCode(item.currency)) + "\n              ")])])
  }), _vm._v(" "), (_vm.TotAMT != 0) ? _c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "5"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('b', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.TotAMT))])]), _vm._v(" "), _c('td')]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-center mt-3",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideNoteModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3c26408","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/ViewNoteDetailsModal.vue
// module id = 2891
// module chunks = 0